import { render } from "./MainMenuDivider.vue?vue&type=template&id=1af49c1f&scoped=true&ts=true"
import script from "./MainMenuDivider.vue?vue&type=script&lang=ts"
export * from "./MainMenuDivider.vue?vue&type=script&lang=ts"

import "./MainMenuDivider.vue?vue&type=style&index=0&id=1af49c1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af49c1f"]])

export default __exports__